import type { FortressKit } from "../kit/types";

/**
 * The Starfall Citadel — the fortress skin of the Starfall family, dropped by the Starfall Wyrm (1 wave in 1,000; the
 * rarest cosmetic in the game). Its own model on all three tiers (`art/hq/base_t<1-3>__starfall.glb`, a fresh bake of
 * the six-cell fortress by tools/art/skins/starfall_fortress.py on art/framework, like the Dragonlord and the Moonstone
 * Keep): an opal keep — pearl masonry with an opal fire drifting through it and baked glitter — prismatic lilac roofs,
 * rose-platinum fittings; a great faceted star-crystal over the keep (the strike conductor's tip, `condgem0`: the bolt
 * leaves the star) inside a prism ring (`starring`, t2+ a second ring of star beads), six prism shards orbiting it
 * trailing sparkles; four crystal spires on the keep and every roof finial crowned with spinning star-crystals;
 * constellation star-veins through the keep and the walls whose star nodes twinkle; glitter over every roof; banners
 * of night-sky cloth sewn with stars and a comet; star-motes rising off the keep all the time.
 * Clips build / idle / charge / fire + `show`: a starfall at level start — the star falls out of the sky on its comet
 * tail and lands on the keep at 2.0 s, where the reveal beat bursts rose and lilac off it (views/towerMotion.ts
 * starburst); the rings and shards burst out of it and every spire's star flares in turn.
 * Fortress v2 (2026-10-19): rebuilt on the new fortress (art/fortress/skin_starfall.py); shooting stars streak out of
 * the sky and land on the spire stars in bursts (views/fortressAmbience.ts). In a level: rose sparkles and rising cyan-white motes burst off the star every 1.4–1.8 s, and the strike is a
 * prismatic white-lilac bolt.
 */
export const STARFALL_FORTRESS: FortressKit = {
  id: "fortress.starfall",
  model: "starfall",
  idle: { kind: "sparkles", colour: 0xffc4ec, every: [1.4, 1.8], count: 3, radius: 0.32, node: "condgem0", also: { kind: "motes", colour: 0xc8f6ff, count: 3, radius: 0.5 } },
  strike: { core: [1, 0.97, 1], rim: [0.86, 0.66, 1], hex: 0xe2a8ff, coreHex: 0xfff4ff },
  reveal: "starburst",
  // fortress v2 (2026-10-19): shooting stars streak in and land on the spire stars
  ambience: { kind: "starfall", every: [1.2, 2.4], colour: [1, 0.82, 0.96], hex: 0xffd0f4 },
};
